import React from "react";
import {
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
} from "@mui/material";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { useNavigate } from "react-router-dom";

const RaceItem = ({ race }: any) => {
  const navigate = useNavigate();

  const navigateToRace = () => {
    navigate("/race", { state: { race } });
  };

  return (
    <Card onClick={navigateToRace}>
      <CardActionArea>
        {race?.image ? (
          <CardMedia
            component="img"
            height="140"
            image={race?.image ?? ""}
            alt="green iguana"
          />
        ) : (
          <CardMedia style={styles.cardNoImage} component="div">
            <ImageNotSupportedIcon color="disabled" sx={styles.iconNoImage} />
          </CardMedia>
        )}
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {race.name.fr}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {race.description?.fr}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const styles = {
  iconNoImage: {
    fontSize: 140,
  },
  cardNoImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "140px", // Assurez-vous que la hauteur est définie pour le contene
  },
};

export default RaceItem;
